module.exports = __webpack_public_path__ + "static/img/A163.32fbb8d9.jpg";